import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import cloneDeep from 'helpers/cloneDeep';
import isJson from 'helpers/isJson';
import TextEditorGenerator from './TextEditorGenerator';

const TextEditorDraft = loadable(() => import('./TextEditorDraft.js'));

class TextEditor extends React.Component {

  constructor() {
    super();

    this.saveChanges = this.saveChanges.bind(this);
  }



  saveChanges(state) {

    const {
      stateAsString
    } = state;

    const contentStateToString = isJson(stateAsString);

    const {
      helpers,
      typeOfStyle,
      editorViewportContent,
      content,
      language = 'en',
      componentPayload
    } = this.props;

    if (!typeOfStyle) return;

    const { setSectionsEditData } = helpers;

    const isBase = editorViewportContent === '0' || !editorViewportContent ;

    const thisViewportContent = isBase ? language : editorViewportContent;

    const thisContent = cloneDeep(componentPayload.content);

    const newContent = {};

    if (thisContent) Object.entries(thisContent).forEach(([key, value]) => {

      if (key === typeOfStyle) {
        Object.entries(value).forEach(([keyWidth, valueWidth]) => {

          const isThisJson = valueWidth && valueWidth['en'] ? isJson(valueWidth['en']) : '';

          if (isThisJson) {

            const thisBlock = cloneDeep(contentStateToString);
   
            const parseThisBlock = isThisJson;

            const newBlocks = thisBlock.blocks.map((block, i) => {
              if (key === typeOfStyle && keyWidth === thisViewportContent) return block;
              if (parseThisBlock && parseThisBlock.blocks[i]) {
                const newPayload = parseThisBlock.blocks[i];
                newPayload.text = block.text;
                return newPayload;
              } else {
                return block;
              }
            }).filter((a) => a);
            if (!newContent[key]) newContent[key] = {};
            if (!newContent[key][keyWidth]) newContent[key][keyWidth] = {};
            if (!newContent[key][keyWidth]['en']) newContent[key][keyWidth]['en'] = {};
            newContent[key][keyWidth]['en'] = JSON.stringify({...thisBlock, blocks: newBlocks});
            
          } else if (typeof valueWidth === 'string') {

            const thisBlockString = cloneDeep(contentStateToString);
            const parseThisBlockString = isJson(valueWidth);

            const newBlocksString = thisBlockString.blocks.map((block, i) => {
              if (key === typeOfStyle && keyWidth === thisViewportContent) return block;
              if (parseThisBlockString && parseThisBlockString.blocks[i]) {
                const newPayload = parseThisBlockString.blocks[i];
                newPayload.text = block.text;
                return newPayload;
              } else {
                return block;
              }

            }).filter((a) => a);
            if (!newContent[key]) newContent[key] = {};
            if (!newContent[key][keyWidth]) newContent[key][keyWidth] = {};

            newContent[key][keyWidth] = JSON.stringify({...thisBlockString, blocks: newBlocksString});
          }
  
        });


      } else {
        newContent[key] = value;
      }

    });


    if (!newContent[typeOfStyle] || isBase && !newContent[typeOfStyle][thisViewportContent] || !isBase && (!newContent[typeOfStyle][thisViewportContent] || !newContent[typeOfStyle][thisViewportContent]['en'])) {
     if (isBase) {
      if (!newContent[typeOfStyle]) newContent[typeOfStyle] = {};
      if (!newContent[typeOfStyle][thisViewportContent]) newContent[typeOfStyle][thisViewportContent] = stateAsString;
     } else {
      if (!newContent[typeOfStyle]) newContent[typeOfStyle] = {};
      if (!newContent[typeOfStyle][thisViewportContent]) newContent[typeOfStyle][thisViewportContent] = {};
      if (!newContent[typeOfStyle][thisViewportContent]['en']) newContent[typeOfStyle][thisViewportContent]['en'] = stateAsString;

      if (!newContent[typeOfStyle]['en']) newContent[typeOfStyle]['en'] = stateAsString;
     }
    }

    const originalMergeObject = componentPayload && componentPayload.content && componentPayload.content[typeOfStyle] ? componentPayload.content[typeOfStyle] : {};
    const newMergeObject = newContent && newContent[typeOfStyle] ? newContent[typeOfStyle] : {};

    const mergeObjects = {
      [typeOfStyle]: {...originalMergeObject, ...newMergeObject}
    };

    setSectionsEditData({
      updateType: 'content',
      value: mergeObjects
    });
    this.props.handleIsEditable(true);
  }


  render() {
    
    const {
      isEditor,
      isEditable,
      isCurrent,
      customStyles,
      componentPayload
    } = this.props;

    if (isEditor && isEditable && isCurrent) {
      return (
        <TextEditorDraft
          {...this.props}
          saveChanges={this.saveChanges}
          customStyles={customStyles}
        />
      );
    }

    return (
      <TextEditorGenerator
        {...this.props}
      />
    );

  }

}

TextEditor.propTypes = {
  isEditor: PropTypes.bool,
  isEditable: PropTypes.bool,
  isCurrent: PropTypes.bool
};


export default TextEditor;
